import React from "react";

export const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = "Да", cancelText = "Отмена" }) => {
    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content modal-content--small" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{title}</h2>
                </div>

                <div className="modal-body">
                    <p>{message}</p>
                </div>

                <div className="modal-footer">
                    <button className="btn btn_secondary" onClick={onClose}>
                        {cancelText}
                    </button>
                    <button className="btn btn_primary" onClick={handleConfirm}>
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};
